// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20GKj","colBig":"styles_colBig__3pmcX","colSmall":"styles_colSmall__2xHdX"};